import { Orientation, TourStep } from 'ngx-guided-tour';

export class TourSteps {
    public static createDashboardTourSteps(
        canViewReports: boolean,
        canViewRequestFunds: boolean
    ): TourStep[] {
        return [
            {
                title: 'Welcome to Dashboard',
                content:
                    'This quick tutorial will highlight some of the features we offer as well as some general navigation tips.<br/><br/>If you would like to stop this tour at any time, simply press the <b>Skip</b> button below.'
            },
            {
                title: 'Navigation',
                selector: '#navbar-nav-left',
                content:
                    'The navigation bar has been organized to put often needed and important pages at your fingertips throughout your visit to the site.  These pages will always be available on this top tab, regardless of whatever page you are currently viewing.',
                orientation: Orientation.Bottom
            },
            {
                title: 'Home page',
                selector: '.navbar-brand lsq-icon',
                content:
                    'You can click the LSQ logo from any page to navigate back to the home page.',
                orientation: Orientation.BottomLeft,
                useHighlightPadding: true
            },
            {
                title: 'The ? Icon',
                selector: '#funds-outstanding-card-tour .dashboard-label-popover',
                content:
                    'While navigating Dashboard, you may notice this icon. Hovering your cursor over the icon will reveal an information box explaining the meaning behind each term or calculation in question.',
                orientation: Orientation.TopRight,
                skipStep: !canViewReports
            },
            {
                title: 'Links',
                selector: '#available-funds-link-tour a',
                content:
                    "You'll also find green text links throughout the various reports and pages. These links will allow you to quickly access more information.<br/><br/>For example, clicking on the Available Funds link will take you to the Available Funds Summary report, which provides a detailed breakdown of how that number is calculated.",
                orientation: Orientation.Bottom,
                useHighlightPadding: true,
                skipStep: !canViewReports || !canViewRequestFunds
            }
        ];
    }

    public static createCustomerTourSteps(hasCustomers: boolean): TourStep[] {
        return [
            {
                title: 'Welcome to your Customers!',
                content:
                    'This quick tutorial is to introduce you to LSQ’s credit process. One of the services we’re proud to offer is the ability to analyze the credit worthiness of your customers.  Your customers’ credit limits are important to monitor, as each limit represents the dollar amount that LSQ is able to fund in invoices for each customer.'
            },
            {
                title: 'When should I request increases?',
                selector: '.customer-credit-limit-increase',
                content:
                    'When managing your customer’s credit, you’ll always want to request new credit and increases as far in advance as possible.  This will allow our credit team time to review and process your request in a timely manner.  To submit an increase request, just click here.',
                orientation: [
                    {
                        orientationDirection: Orientation.Bottom
                    }
                ],
                useHighlightPadding: true,
                skipStep: !hasCustomers,
                scrollAdjustment: 40
            },
            {
                title: 'Don’t see your customer listed?',
                selector: '#customers-filters-form',
                content:
                    'If you don’t see your customer listed, try filtering your customer list to show more options using the filter button.',
                orientation: Orientation.Bottom,
                useHighlightPadding: true
            },
            {
                title: 'Still don’t see your customer listed?',
                selector: '.add-new-customer-button',
                content: 'If you still don’t see your customer, you can add that customer here.',
                orientation: Orientation.Left,
                useHighlightPadding: true
            }
        ];
    }
    public static createUploadInvoiceTourSteps(): TourStep[] {
        return [
            {
                title: 'Welcome to your Upload Invoices page!',
                content:
                    'This is a quick tutorial to outline the process of sending your unpaid invoices to LSQ for processing.<br/><br/>If you would like to stop this tour at any time, simply press the <b>Skip</b> button below.'
            },
            {
                title: 'Tell us about your invoices',
                selector: '.cover-sheet-form-amounts',
                content:
                    'First, let us know the total dollar amount that you’ll be uploading.  And, while not required, the total number of your invoices will also help us process your submission.',
                orientation: Orientation.Right,
                useHighlightPadding: true
            },
            {
                title: 'Select your Funding Method',
                selector: '.funding-method-section',
                content:
                    'For each upload you’ll have the option to customize how your invoices are funded. You’ll also be able to change the bank account that funds from your invoices will be sent to by selecting an existing account from the dropdown menu.',
                orientation: Orientation.Top,
                useHighlightPadding: true
            }
        ];
    }
    public static createRequestsFundsTourSteps(): TourStep[] {
        return [
            {
                title: 'Funding Status',
                selector: '.request-funds-history-card .card-header',
                content:
                    'Once you’ve submitted your funding request, you’ll be able to view it and track the current status which is updated in real time.  You’ll also be able to see the past 30 days of funding requests here, as well.',
                orientation: [
                    {
                        orientationDirection: Orientation.Left
                    },
                    {
                        orientationDirection: Orientation.Top,
                        maximumSize: 1200
                    }
                ]
            }
        ];
    }
}

export class TourAnalyticsNames {
    public static readonly DashboardIntro = 'dashboard intro tour';
    public static readonly CustomersIntro = 'customers intro tour';
    public static readonly UploadIntro = 'upload intro tour';
    public static readonly RequestFundsTips = 'request funds tip tour';
}

export class TourIds {
    public static readonly DashboardIntro = 'dashboard-intro-tour';
    public static readonly CustomersIntro = 'customers-intro-tour';
    public static readonly UploadIntro = 'upload-intro-tour';
    public static readonly RequestFundsTips = 'request-funds-tip-tour';
}
